import { useEffect } from "react";
import { ShieldAlert } from "lucide-react";

// Deep-link gatekeeper for the in-development Road Shooter / Space game route
// (/play/space). Non-founders who type or open the route get a clean Access
// Denied screen and are pushed back to the main app.
export default function GameLocked() {
  useEffect(() => {
    const t = setTimeout(() => { window.location.href = "/"; }, 2400);
    return () => clearTimeout(t);
  }, []);
  return (
    <div
      data-testid="game-access-denied"
      className="flex h-[100dvh] w-full flex-col items-center justify-center gap-5 bg-[#0b0b0b] px-8 text-center"
    >
      <div className="grid h-20 w-20 place-items-center rounded-2xl border-2 border-red-400/40 bg-red-400/10">
        <ShieldAlert size={38} className="text-red-400" />
      </div>
      <h1 className="font-serif text-3xl text-white">Access Denied</h1>
      <p className="max-w-[300px] font-mono text-[12px] leading-relaxed text-white/55">
        This experience is still in development and isn't open yet. Taking you back to Misteck…
      </p>
      <button
        onClick={() => { window.location.href = "/"; }}
        data-testid="game-denied-back"
        className="rounded-full border-2 border-white/20 bg-white/[0.06] px-6 py-3 font-mono text-[11px] font-black uppercase tracking-widest text-white active:scale-95"
      >
        Back to Misteck
      </button>
    </div>
  );
}
